<template>
  <div>for develop. sign in specify user, and get user status info!</div>
</template>
<script>
// import { authStatus, reftoken } from "@/service";

export default {
  name: "user-status",
  data() {
    return {

    };
  },
  created() {
    this.syncFetch()
  },
  methods: {
    // 本地测试
    async syncFetch() {
      // const api = 'http://52.83.189.182:18080'
      // const api = 'https://api.iiot-tst.gdnash.com.cn' //staging
      // const api = 'https://api.iiot-test.gdnash.com.cn'
      const api = 'https://api.iiot-demo.gdnash.com.cn'
      let userConfig = [
        // 代理商管理员
        // {
        //   username: 'dlam',
        //   password: '123456'
        // },
        //  // nash客户管理员
        //  {
        //   username: 'daxiong',
        //   password: '123456'
        // },
        // 销售服务工程师
        // {
        //   username: 'goldendata',
        //   password: 'VGT7rtj!ayd.nge0cda'
        // },
        {
          username: 'admin',
          password: 'jvj-DQR3vby8rpf_nqj'
        },
        // {
        //   username: 'Runtech',
        //   password: '123456'          
        // }
        // {
        //   username: 'test',
        //   password: '123456'
        // },
        // {
        //   password:"Goldendata8888",
        //   username:"demo@goldendata.cloud"
        // }
        // // 技术服务工程师
        // {
        //   username: 'shandong1',
        //   password: '123456'
        // }
        // 本地测试账户
        // {
        //   username: 'sadmin',
        //   password: '123456'
        // }
      ]

      const username = userConfig[0].username
      // const username = "14985740"
      const password = userConfig[0].password

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      };

      let response = await fetch(`${api}/rest-api/auth/login`, requestOptions)
      let res = await response.json();

      localStorage.setItem("accessToken", res.payload.accessToken);
      localStorage.setItem("expiresAt", new Date(res.payload.expiresAt * 1000).toISOString());
      localStorage.setItem("refreshToken", res.payload.refreshToken);
      localStorage.setItem("refreshExpiresIn", new Date(res.payload.refreshExpiresIn * 1000).toISOString());

      const statusRequestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + res.payload.accessToken
        },
      };

      response = await fetch(`${api}/wo/api/auth/status`, statusRequestOptions)
      res = await response.json();

      localStorage.setItem('user', JSON.stringify(res.payload.user || []))
      localStorage.setItem('permission', JSON.stringify(res.payload.permission || []))
      localStorage.removeItem('login_redirect')
    }
  },

}
</script>
